<template>
  <v-dialog v-model="isDialogOpen" max-width="850">
    <v-card class="pa-4">
      <v-card-title
      class="common-font-size title-position" id="tmc-blue">ReNewGov
      </v-card-title>
      <v-card-text>
        <v-row class="d-flex justify-space-around">
          <v-col cols="5" class="elevation-1 pa-4">
            <p class="text-center text-subtitle-1 header-class">Payment Details</p>
            <div v-if="payrixPaymentType === 'CREDIT'">
              <label for="number">Card Number</label>
              <div id="number" class="form-row"></div>
              <label for="expiration">Expiration</label>
              <div id="expiration" class="form-row"></div>
              <label for="cvv">CVV</label>
              <div id="cvv" class="form-row"></div>
              <label for="name">Name</label>
              <div id="name" class="form-row"></div>
            </div>
            <div v-if="payrixPaymentType === 'ECHECK'">
              <label for="account_type">Account Type</label>
              <div id="account_type" class="form-row"></div>
              <div class="mt-3 input-field">
              <label for="custom-routing">Routing Number</label>
              <input
                type="custom-routing"
                id="custom-routing"
                name="custom-routing"
                placeholder="12345678"
                v-model="customRoutingNumber"
                @input="bankLookup"
              >
            </div>
            <div v-if="bankName" class="bank-name-display">
              <span class="bank-name-text">{{  bankName }}</span>
            </div>
            <div v-else-if="missingBankMessage
              && customRoutingNumber
              && customRoutingNumber.length === 9" class="missing-bank-display">
              <span class="missing-bank-text">{{ missingBankMessage }}</span>
            </div>
            <div v-else-if="customRoutingNumber
              && customRoutingNumber.length > 0 && customRoutingNumber.length !== 9"
              class="invalid-routing-display">
              <span class="invalid-routing-text">Please enter a valid routing number</span>
            </div>
              <label for="routing">Confirm Routing Number</label>
              <div id="routing" class="form-row"></div>
              <label for="account_number">Account Number</label>
              <div id="account_number" class="form-row"></div>
              <label for="name">Name</label>
              <div id="name" class="form-row"></div>
            </div>
            <div class="mt-3 input-field">
              <label for="phone-number">Phone Number (optional)</label>
              <input
                type="tel"
                id="phone-number"
                name="phone-number"
                v-model="phoneNumber"
                placeholder="(555) 123-4567"
                @input="validatePhoneNumber"
                :class="{'invalid-input': phoneNumberError}"
              >
            </div>
            <div v-if="phoneNumberError" class="error-text">
              Please enter a valid phone number (numbers, parentheses, hyphens only).
            </div>
            <div class="input-field">
              <label for="email">Email
                <span v-if="emailReceipt" class="red-text">(required for email receipt)</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                v-model="email"
                :required="emailReceipt"
                :aria-required="emailReceipt ? 'true' : 'false'"
                placeholder="email@domain.com"
                @input="validateEmail"
                :class="{'invalid-input': emailError}"
                >
            </div>
            <div v-if="paymentContext === 'TAX'" class="email-receipt">
              <v-checkbox
                v-model="emailReceipt"
                label="Email receipt"
                @change="onEmailReceiptToggle"
              ></v-checkbox>
            </div>
            <div v-if="emailError" class="error-text">
              <span v-if="emailReceipt">A valid email is required to email the receipt.</span>
              <span v-else>Please enter a valid email address.</span>
            </div>
          <div v-if="payrixPaymentType === 'CREDIT'" class="swipe-popup-container mt-3">
            <v-btn
              id="swipeBtn"
              small
              class="swipe-btn"
              @click="handleSwipeCard"
              style="max-width: 150px; margin: 0 auto;"
            >
            Re-swipe
            </v-btn>
          </div>
          </v-col>
            <v-col cols="6" class="elevation-1 pa-4">
            <p class="text-center text-subtitle-1 header-class">Checkout Details</p>
            <v-row>
              <v-col cols="6" class="d-flex flex-column ml-4">
                <span v-for="fieldName in fieldNameLists" :key="fieldName">
                  <label class="input-text-size">{{ fieldName }}:</label>
                </span>
              </v-col>
              <v-col cols="4" class="d-flex flex-column align-end mr-4">
                <span v-for="(amt, i) in fieldAmtLists" :key="`amt-${i}`">
                  <label class="or-text">${{ amountFormat(amt) }}</label>
                </span>
              </v-col>
            </v-row>
            <v-divider class="my-3"></v-divider>
            <v-row v-if="!isVerified" dense class="fee-row">
              <v-col cols="6" class="ml-4">
                <label v-if="payrixPaymentType === 'CREDIT'"
                  class="input-text-size font-weight-bold green--text">
                  Total + (credit fee)
                </label>
                <label v-else-if="payrixPaymentType === 'ECHECK'"
                  class="input-text-size font-weight-bold green--text">
                  Total + eCheck fee
                </label>
              </v-col>
              <v-col cols="4" class="text-right mr-4">
                <label v-if="payrixPaymentType === 'CREDIT'"
                  class="input-text-size font-weight-bold green--text">
                  ${{ amountFormat(totalPlusCreditFee) }}
                </label>
                <label v-else-if="payrixPaymentType === 'ECHECK'"
                  class="input-text-size font-weight-bold green--text">
                  ${{ amountFormat(totalPlusEcheckFee) }}
                </label>
              </v-col>
            </v-row>
            <v-row v-if="payrixPaymentType === 'CREDIT' && !isVerified" dense class="or-divider">
              <v-col cols="6" class="ml-4">
                <label class="input-text-size">-- or --</label>
              </v-col>
            </v-row>
            <v-row v-if="payrixPaymentType === 'CREDIT' && !isVerified" dense class="fee-row">
              <v-col cols="6" class="ml-4">
                <label class="input-text-size font-weight-bold green--text">
                  Total + (debit fee)</label>
              </v-col>
              <v-col cols="4" class="text-right mr-4">
                <label class="input-text-size font-weight-bold green--text">
                  ${{ amountFormat(totalPlusDebitFee) }}
                </label>
              </v-col>
            </v-row>
            <!-- Verified fee display after bin check -->
            <v-row v-if="isVerified && verifiedBinInfo" dense class="verified-fee-section">
              <v-col cols="12" class="text-center pa-3">
                <v-alert type="info" dense text class="mb-2">
                  <div class="verified-card-type">{{ verifiedCardTypeDisplay }}</div>
                </v-alert>
                <div class="verified-fee-details">
                  <span class="verified-label">Fee:</span>
                  <span class="verified-value">${{ amountFormat(verifiedFeeAmount) }}</span>
                </div>
                <div class="verified-total-details">
                  <span class="verified-label">Total to charge:</span>
                  <span class="verified-value font-weight-bold">
                    ${{ amountFormat(verifiedTotalAmount) }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row justify="center" class="submit-button-row">
              <v-btn v-if="payrixPaymentType === 'CREDIT' && isVerified"
                class="input-text-size rounded elevation-2 cancel-verify-btn mr-2"
                color="grey darken-1"
                outlined
                :disabled="isProcessing"
                @click="cancelVerification"
              >
                Cancel
              </v-btn>
              <v-btn v-if="payrixPaymentType === 'CREDIT'"
                class="input-text-size rounded elevation-4 payment-submit-btn"
                :color="isVerified ? 'blue darken-2' : 'green darken-1'"
                dark
                :disabled="disablePay"
                @click="submitPayment"
              >
                {{ creditButtonText }}
              </v-btn>
              <v-btn v-if="payrixPaymentType === 'ECHECK'"
                class="input-text-size rounded elevation-4 payment-submit-btn"
                color="green darken-1"
                dark
                :disabled="!bankName"
                @click="submitPayment"
              >
                {{ isProcessing ? 'Processing...' : 'Submit Payment' }}
              </v-btn>
            </v-row>
            <v-alert
              v-if="paymentMessage"
              :type="processedPayment ? 'success' : 'error'"
              dense
              text
              class="mt-3"
            >
              {{ paymentMessage }}
            </v-alert>
            <div v-if="payrixPaymentType === 'CREDIT'"
              class="mt-auto pt-4 text-center card-group-section">
                <img src="https://img.icons8.com/color/48/000000/mastercard-logo.png" class="accepted-card-icon">
                <img src="https://img.icons8.com/color/48/000000/visa.png" class="accepted-card-icon">
                <img src="https://img.icons8.com/color/48/000000/discover.png" class="accepted-card-icon">
                <img src="https://img.icons8.com/color/48/000000/amex.png" class="accepted-card-icon">
            </div>
          </v-col>
        </v-row>
        <v-row v-if="payrixPaymentType === 'CREDIT' && !isVerified">
          <v-col class="adjusted-text">
            * Fee calculations: Credit ({{ paymentSettingItem.payrixCreditPercentage }}%)
            | Debit ({{ paymentSettingItem.payrixDebitPercentage }}%)
            | Chase Business Credit (3.25%)
            <span v-if="paymentSettingItem.payrixDebitAmtLimit > 0">
              | $3.95 flat fee for debit under ${{ paymentSettingItem.payrixDebitAmtLimit }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text @click="handleClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* global PayFields */
import {
  mapState,
  mapActions,
} from 'vuex';
import axios from 'axios';
import { amountFormat } from '../../util/shared/vue-global';
import { processPayment, getBinCheckInfo } from '../../util/processCreditCard/payrix.util';
import { createSwipeDiagnostics } from '../../util/processCreditCard/swipeDiagnostics';
import { getWorkstationNumber } from '../../util/workstation-util';
import { clients } from '../../util/clients';

const { backendRest } = clients.direct;

// PayFields answers submit() through its hidden iframes. Its own message handler
// can throw before it calls onFailure (appendErrors dereferences a `msg` the API
// does not always send), in which case no callback ever runs and nothing clears
// isProcessing - the dialog then sits on "Verifying..." forever. Give up after this.
const SUBMIT_TIMEOUT_MS = 30000;

export default {
  name: 'PayrixPaymentDialog',
  props: {
    fieldNameLists: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    phoneNumber: null,
    email: null,
    phoneNumberError: false,
    emailError: false,
    paymentMessage: null,
    processedPayment: null,
    isProcessing: false,
    customRoutingNumber: null,
    bankName: null,
    missingBankMessage: null,
    emailReceipt: false,
    // Bin check verification state
    isVerified: false,
    isVerifying: false,
    verifiedToken: null,
    verifiedBinInfo: null,
    // Passive diagnostics session, replaced by startSwipeDiagnostics() once the
    // county config is known. Starts as a disabled no-op so that every call site
    // is safe even if the dialog tears down before the config loads.
    swipeDiag: createSwipeDiagnostics({ enabled: false }),
    // Swipe-cancel listener and submit timeout (see resetSwipeState below)
    payrixMessageHandler: null,
    submitWatchdog: null,
  }),
  computed: {
    ...mapState('common/payrixPayment', ['payrixPaymentData', 'paymentSuccessFlag', 'payrixPaymentType', 'paymentContext', 'odDepositData', 'taxCartContents', 'miscReceiptData', 'mtgReceiptData']),
    ...mapState({
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem, // for TAX
      odSettingItem: (state) => state.SystemConfig.odSettingItem,
      miscSettingItem: (state) => state.SystemConfig.miscSettingItem,
      mtgSettingItem: (state) => state.SystemConfig.mtgSettingItem,
      taxDetails: (state) => state.tax.taxPayment.taxDetails,
    }),
    resolvedMerchantId() {
      if (this.paymentContext === 'OD') return this.odSettingItem.payrixMerchentId;
      if (this.paymentContext === 'MISC') return this.miscSettingItem.payrixMerchantId;
      if (this.paymentContext === 'MTG') return this.mtgSettingItem.payrixMerchantId;
      return this.paymentSettingItem.posMerchantId;
    },
    isDialogOpen: {
      get() {
        return this.$store.state.common.payrixPayment.isDialogOpen;
      },
      set(val) {
        this.$store.commit('common/payrixPayment/setDialogOpen', val);
      },
    },
    fieldAmtLists() {
      if (this.payrixPaymentType === 'CREDIT') {
        return [
          (this.payrixPaymentData && this.payrixPaymentData.totalAmount) || 0,
          (this.payrixPaymentData && this.payrixPaymentData.convenienceFeeCredit) || 0,
          (this.payrixPaymentData && this.payrixPaymentData.convenienceFeeDebit) || 0,
        ];
      }
      if (this.payrixPaymentType === 'ECHECK') {
        return [
          (this.payrixPaymentData && this.payrixPaymentData.totalAmount) || 0,
          (this.payrixPaymentData && this.payrixPaymentData.eCheckFee) || 0,
        ];
      }
      return [];
    },
    totalPlusCreditFee() {
      return (this.payrixPaymentData && this.payrixPaymentData.totalPlusCreditFee) || 0;
    },
    totalPlusDebitFee() {
      return (this.payrixPaymentData && this.payrixPaymentData.totalPlusDebitFee) || 0;
    },
    totalPlusEcheckFee() {
      return (this.payrixPaymentData && this.payrixPaymentData.totalPlusEcheckFee) || 0;
    },
    disablePay() {
      return this.phoneNumberError || this.emailError || this.isProcessing;
    },
    // Verified fee display values (in dollars)
    verifiedFeeAmount() {
      return this.verifiedBinInfo ? (this.verifiedBinInfo.fee / 100) : 0;
    },
    verifiedTotalAmount() {
      return this.verifiedBinInfo ? (this.verifiedBinInfo.totalWithFee / 100) : 0;
    },
    verifiedCardTypeDisplay() {
      if (!this.verifiedBinInfo) return '';
      return `${this.verifiedBinInfo.cardType} ${this.verifiedBinInfo.binType}`.toUpperCase();
    },
    // Button text based on state
    creditButtonText() {
      if (this.isProcessing && !this.isVerified) return 'Verifying...';
      if (this.isProcessing && this.isVerified) return 'Processing...';
      if (this.isVerified) return 'Submit Payment';
      return 'Verify Fee';
    },
  },
  mounted() {
    this.loadPayFieldsScript().then(() => {
      this.initializePayFields();
    });
    this.requestId = `payrix-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
  },
  beforeDestroy() {
    this.clearSubmitWatchdog();
    this.detachPayrixMessageListener();
    this.flushSwipeDiagnostics();
  },
  methods: {
    ...mapActions('common/payrixPayment', ['toggleDialog', 'setPaymentSuccessFlag', 'setPayrixPaymentType', 'setCardholderInfo', 'setPayrixPaymentData']),
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions(['flashSuccess', 'flashError']),
    amountFormat,
    /*
     * PayFields.swiped is a sticky page-level flag: it is only cleared a couple of
     * seconds after a *successful* token response, never by clearFields(),
     * unmountAll() or closing this dialog. While it is true, submit() tells the
     * field iframes to skip their required-field validation, so an empty form is
     * posted to Payrix as if a card had been swiped. Clear it whenever we know
     * there is no captured swipe.
     */
    resetSwipeState() {
      if (typeof PayFields === 'undefined') return;
      PayFields.swiped = false;
    },
    attachPayrixMessageListener() {
      if (this.payrixMessageHandler) return;
      this.payrixMessageHandler = (event) => {
        const payrixOrigin = (typeof PayFields !== 'undefined' && PayFields.api)
          ? PayFields.api.toLowerCase() : '';
        if (!payrixOrigin || !event.origin
          || payrixOrigin.indexOf(event.origin.toLowerCase()) === -1) return;
        let message = null;
        try {
          message = JSON.parse(event.data);
        } catch (err) {
          return; // not a PayFields message
        }
        // Swipe popup closed without a card read (Cancel or backdrop click).
        if (message && message.sender === 'closeSwipe' && !message.swiped) {
          this.resetSwipeState();
          PayFields.clearFields();
        }
      };
      window.addEventListener('message', this.payrixMessageHandler);
    },
    detachPayrixMessageListener() {
      if (!this.payrixMessageHandler) return;
      window.removeEventListener('message', this.payrixMessageHandler);
      this.payrixMessageHandler = null;
    },
    startSubmitWatchdog() {
      this.clearSubmitWatchdog();
      this.submitWatchdog = setTimeout(() => {
        this.submitWatchdog = null;
        if (!this.isProcessing) return;
        console.error('PayFields did not respond to submit()');
        this.swipeDiag.mark('payfields_submit_timeout', { ms: SUBMIT_TIMEOUT_MS });
        this.isProcessing = false;
        this.isVerifying = false;
        this.paymentMessage = 'No response from the card processor. '
          + 'Please re-swipe or enter the card details manually.';
        this.resetSwipeState();
        PayFields.clearFields();
      }, SUBMIT_TIMEOUT_MS);
    },
    clearSubmitWatchdog() {
      if (!this.submitWatchdog) return;
      clearTimeout(this.submitWatchdog);
      this.submitWatchdog = null;
    },
    handleClose() {
      // Flush first: the resets below clear the state the outcome is derived from.
      this.flushSwipeDiagnostics();
      this.clearSubmitWatchdog();
      this.resetSwipeState();
      PayFields.clearFields();
      this.phoneNumber = null;
      this.email = null;
      this.phoneNumberError = false;
      this.emailError = false;
      this.emailReceipt = false;
      this.paymentMessage = null;
      this.processedPayment = null;
      this.bankName = null;
      this.missingBankMessage = null;
      // Reset bin verification state
      this.isVerified = false;
      this.isVerifying = false;
      this.verifiedToken = null;
      this.verifiedBinInfo = null;
      PayFields.unmountAll();
      /*
        * Known Issue: PayFields iframe occasionally throws:
        "Cannot read properties of undefined (reading 'input')" when
        selecting 'Cancel' after a successful payment submission. This error is triggered from:
        https://test-api.payrix.com/js/app/payFieldsForm1.4.3.js and cannot be caught or suppressed due to cross-origin sandbox.
        It is safe to ignore as it does not affect payment flow.
      */
      this.toggleDialog(false);
    },
    async bankLookup() {
      this.bankName = null;
      this.missingBankMessage = null;
      if (this.customRoutingNumber && this.customRoutingNumber.length === 9) {
        try {
          const url = `https://routing-number-api.fly.dev/banks/${this.customRoutingNumber}`;
          const response = await axios.get(url);
          if (response.data.bank) {
            this.bankName = response.data.bank;
          } else {
            this.missingBankMessage = 'BANK NOT FOUND';
          }
        } catch (error) {
          console.info('no bank found');
          this.missingBankMessage = 'BANK NOT FOUND';
        }
      }
    },
    validatePhoneNumber() {
      const validPattern = /^[\d()-]{0,14}$/;
      const digits = this.phoneNumber ? this.phoneNumber.replace(/\D/g, '') : '';
      this.phoneNumberError = !!this.phoneNumber
      && (!validPattern.test(this.phoneNumber) || digits.length < 10);
    },
    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailTrimmed = this.email ? this.email.trim() : '';
      if (this.emailReceipt) {
        this.emailError = emailTrimmed === '' || !emailPattern.test(emailTrimmed);
      } else {
        this.emailError = emailTrimmed !== '' && !emailPattern.test(emailTrimmed);
      }
    },
    startSwipeDiagnostics() {
      // Wrapped whole: this runs inside loadPayFieldsScript, so anything that
      // threw here would stop initializePayFields and break the payment dialog.
      // Diagnostics must never be able to do that.
      try {
        // resolvedMerchantId dereferences odSettingItem/miscSettingItem, which
        // are not guaranteed to be in the store this early in the lifecycle.
        let merchantId = null;
        try {
          merchantId = this.resolvedMerchantId || null;
        } catch (_) {
          merchantId = null;
        }
        // Off unless the county turned it on. createSwipeDiagnostics returns an
        // all-no-op object when disabled, so no caller needs to branch.
        this.swipeDiag = createSwipeDiagnostics({
          enabled: !!(this.paymentSettingItem && this.paymentSettingItem.paymentDiagnostics === true),
          paymentContext: this.paymentContext,
          payrixPaymentType: this.payrixPaymentType,
          workstation: getWorkstationNumber(),
          requestId: this.requestId,
          merchantId,
        });
        this.swipeDiag.attach();
        this.swipeDiag.mark('dialog_opened');
      } catch (_) {
        // Leave the disabled no-op session from data() in place.
      }
    },
    flushSwipeDiagnostics() {
      if (!this.swipeDiag) return;
      try {
        this.flushSwipeDiagnosticsUnsafe();
      } catch (_) {
        // never let diagnostics interfere with closing the dialog
      }
    },
    flushSwipeDiagnosticsUnsafe() {
      let outcome = 'dialog_closed';
      if (this.processedPayment && this.processedPayment.success) {
        outcome = 'payment_success';
      } else if (this.processedPayment) {
        outcome = 'payment_not_completed';
      } else if (this.isVerified) {
        outcome = 'verified_not_submitted';
      } else if (this.isProcessing) {
        outcome = 'closed_while_processing';
      }
      this.swipeDiag.flush(outcome);
      this.swipeDiag.detach();
    },
    async loadPayFieldsScript() {
      await this.loadConfig({ requiredScope: 'odconfig' });
      if (this.paymentContext === 'MISC') {
        await this.loadConfig({ requiredScope: 'miscConfig' });
      }
      if (this.paymentContext === 'MTG') {
        await this.loadConfig({ requiredScope: 'mtgConfig' });
      }
      const { jQueryCdnUrl, payrixCdnUrl } = this.paymentSettingItem;
      const loadScript = (src) => new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
      this.startSwipeDiagnostics();
      const scriptStart = Date.now();
      await loadScript(jQueryCdnUrl);
      this.swipeDiag.mark('jquery_loaded', { ms: Date.now() - scriptStart });
      const payrixStart = Date.now();
      await loadScript(payrixCdnUrl);
      this.swipeDiag.mark('payrix_script_loaded', { ms: Date.now() - payrixStart });
    },
    initializePayFields() {
      const program = this.paymentContext;
      const config = this.paymentSettingItem;
      PayFields.config.apiKey = config.payrixPublicKey;
      if (program === 'TAX') {
        PayFields.config.merchant = config.posMerchantId;
      } else if (program === 'OD') {
        PayFields.config.merchant = this.odSettingItem.payrixMerchentId;
      } else if (program === 'MISC') {
        PayFields.config.merchant = this.miscSettingItem.payrixMerchantId;
      } else if (program === 'MTG') {
        PayFields.config.merchant = this.mtgSettingItem.payrixMerchantId;
      }
      if (this.payrixPaymentType === 'CREDIT') {
        PayFields.config.mode = 'token';
        PayFields.config.swipe = true;
        PayFields.fields = [
          { type: 'number', element: '#number' },
          { type: 'expiration', element: '#expiration' },
          { type: 'cvv', element: '#cvv' },
          { type: 'name', element: '#name' },
        ];
      } else if (this.payrixPaymentType === 'ECHECK') {
        PayFields.config.swipe = false;
        PayFields.config.mode = 'txnToken';
        PayFields.config.txnType = 'ecsale';
        PayFields.fields = [
          { type: 'account_type', element: '#account_type' },
          { type: 'routing', element: '#routing' },
          { type: 'account_number', element: '#account_number' },
          { type: 'name', element: '#name' },
        ];
      }
      PayFields.ready();
      this.swipeDiag.mark('payfields_ready');
      // PayFields is a page-level singleton, so a swipe captured by an earlier
      // dialog can still be flagged as current when this one opens.
      this.resetSwipeState();
      this.attachPayrixMessageListener();
      if (this.payrixPaymentType === 'CREDIT') {
        setTimeout(() => {
          PayFields.swipePopup();
          this.swipeDiag.openSwipeWindow('auto_timer');
        }, 1000);
      }
      PayFields.onValidationFailure = (validationError) => {
        // The error payload is recorded for diagnostics only. Nothing is shown to
        // the operator here, so this does not change existing behaviour.
        this.swipeDiag.mark('payfields_validation_failure', {
          // The whole payload: the three fields picked out here before were a
          // guess at what mattered, and anything else Payrix sent was lost.
          validationError,
          field: (validationError && validationError.field) || null,
          subField: (validationError && validationError.subField) || null,
          swiped: typeof PayFields.swiped === 'boolean' ? PayFields.swiped : null,
        });
        this.clearSubmitWatchdog();
        this.isProcessing = false;
        this.isVerifying = false;
      };
      PayFields.onSuccess = (res) => {
        // Recorded so a working swipe on a machine is directly comparable with a
        // failing one. The response is sanitized by the collector before storage.
        this.swipeDiag.mark('payfields_success', {
          response: res,
          swiped: typeof PayFields.swiped === 'boolean' ? PayFields.swiped : null,
        });
        this.clearSubmitWatchdog();
        // A throw inside the async handler (a malformed response, a failing
        // receipt call) would otherwise leave isProcessing true forever and lock
        // the dialog on "Verifying...".
        this.handlePayFieldsSuccess(res).catch((err) => {
          console.error('Payrix payment handling failed:', err);
          this.swipeDiag.mark('payfields_success_handler_error', { error: err });
          this.paymentMessage = `Payment error: ${err.message || 'Unexpected error'}`;
          this.isProcessing = false;
          this.isVerifying = false;
          this.resetSwipeState();
        });
      };
      PayFields.onFailure = (error) => {
        console.error('PayFields error:', error);
        // The whole error object, not just the event name. Payrix puts its reason
        // for rejecting a card in here and it was previously going only to the
        // browser console, which is why swipe failures had no recorded cause.
        this.swipeDiag.mark('payfields_failure', {
          error,
          swiped: typeof PayFields.swiped === 'boolean' ? PayFields.swiped : null,
        });
        this.clearSubmitWatchdog();
        this.isProcessing = false;
        this.isVerifying = false;
        this.paymentMessage = 'The card could not be processed. '
          + 'Please re-swipe or enter the card details manually.';
        this.resetSwipeState();
      };
    },
    async handlePayFieldsSuccess(res) {
      const data = (res && res.data) || [];
      const token = this.payrixPaymentType === 'CREDIT'
        ? (data[0] && data[0].token)
        : (data[0] && data[0].token && data[0].token.token);

      // CREDIT CARD: Two-step flow - verify first, then submit
      if (this.payrixPaymentType === 'CREDIT' && !this.isVerified) {
        // Step 1: Bin check verification
        this.swipeDiag.mark('bin_check_start', {
          swiped: typeof PayFields.swiped === 'boolean' ? PayFields.swiped : null,
        });
        const binCheckStart = Date.now();
        const binInfo = await getBinCheckInfo(
          token,
          (this.payrixPaymentData && this.payrixPaymentData.totalAmount),
          this.paymentSettingItem,
        );
        this.swipeDiag.mark('bin_check_end', {
          ms: Date.now() - binCheckStart,
          ok: !(binInfo && binInfo.error),
          binType: (binInfo && binInfo.binType) || null,
          cardType: (binInfo && binInfo.cardType) || null,
        });

        if (binInfo.error) {
          this.paymentMessage = `Verification failed: ${binInfo.error}`;
          this.isVerifying = false;
          this.isProcessing = false;
          return;
        }

        // Per-row fee waiver: zero fee so display AND actual charge are amount-only.
        if (this.payrixPaymentData && this.payrixPaymentData.waiveFees) {
          const totalAmt = (this.payrixPaymentData && this.payrixPaymentData.totalAmount) || 0;
          binInfo.fee = 0;
          binInfo.totalWithFee = Math.round(totalAmt * 100);
        }

        // Store verified info for payment submission
        this.verifiedToken = token;
        this.verifiedBinInfo = binInfo;
        this.isVerified = true;
        this.isVerifying = false;
        this.isProcessing = false;
        this.paymentMessage = null;

        // Update displayed fee amounts to match the BIN-checked fee
        // (e.g. Chase Business Visa BIN 424631 charges 3.25% instead of standard rate)
        const verifiedFee = binInfo.fee / 100;
        const verifiedTotal = binInfo.totalWithFee / 100;
        this.setPayrixPaymentData({
          ...this.payrixPaymentData,
          convenienceFeeCredit: verifiedFee,
          totalPlusCreditFee: verifiedTotal,
        });
        return;
      }

      // Step 2: Process payment (CREDIT after verification, or ECHECK after)
      let cartContents;
      if (this.paymentContext === 'TAX') {
        cartContents = this.taxCartContents;
      } else if (this.paymentContext === 'MISC') {
        cartContents = this.miscReceiptData;
      } else if (this.paymentContext === 'MTG') {
        cartContents = this.mtgReceiptData;
      } else {
        cartContents = this.odDepositData;
      }

      // For credit cards, use the verified token and bin info
      const paymentToken = this.payrixPaymentType === 'CREDIT' ? this.verifiedToken : token;

      this.processedPayment = await processPayment(
        paymentToken,
        this.phoneNumber,
        this.email,
        (this.payrixPaymentData && this.payrixPaymentData.totalAmount),
        cartContents,
        this.paymentSettingItem,
        this.payrixPaymentType,
        this.paymentContext,
        (this.payrixPaymentData && this.payrixPaymentData.ownerName),
        this.requestId,
        this.verifiedBinInfo, // Pass pre-calculated bin info to skip confirm dialog
        this.resolvedMerchantId,
      );
      if (this.processedPayment && this.processedPayment.success) {
        this.paymentMessage = 'Payment successful!';
        this.phoneNumber = this.processedPayment.phoneNumber || '';
        this.email = this.processedPayment.emailAddress || '';
        const returnedCardholderName = this.processedPayment.cardholderName || '';
        const fallbackOwnerName = (this.payrixPaymentData && this.payrixPaymentData.ownerName) || '';
        this.cardholderName = returnedCardholderName.length > 2
          ? returnedCardholderName : fallbackOwnerName;
        this.cardType = this.processedPayment.cardType || '';
        this.paymentMethod = this.payrixPaymentType === 'CREDIT'
          ? `${this.cardType}_PAYRIX`
          : 'ECHECK_PAYRIX';

        this.setPaymentSuccessFlag({
          flag: true,
          transactionId: this.processedPayment.transactionId || '',
        });
        this.setPayrixPaymentType(this.payrixPaymentType);
        this.setCardholderInfo({
          phone: this.phoneNumber,
          email: this.email,
          cardholderName: this.cardholderName,
          paymentMethod: this.paymentMethod,
        });
        /* POST API to backend to generate receipt pdf and open in new tab */
        await this.generateReceipt(this.paymentContext);
        // Close modal after successful payment
        this.isProcessing = false;
        this.handleClose();
        return;
      }
      if (this.processedPayment.reason === 'canceled') {
        this.paymentMessage = 'Payment was canceled by user.';
      } else if (this.processedPayment.reason === 'declined') {
        this.paymentMessage = 'Payment was declined.';
      } else if (this.processedPayment.reason === 'unknown_status') {
        this.paymentMessage = 'Payment status unknown. Please check your ReNewGov Portal.';
      } else if (this.processedPayment.error) {
        // Specific error messages from Payrix or backend processing
        this.paymentMessage = `Payment failed: ${this.processedPayment.error}`;
      } else {
        // Technical errors (network issues, API failures, etc.)
        this.paymentMessage = 'Payment could not be processed. Please try again.';
      }
      this.processedPayment = null;

      this.isProcessing = false;
      this.customRoutingNumber = '';
      this.phoneNumber = null;
      this.email = null;
      // Reset verification state after payment attempt
      this.isVerified = false;
      this.verifiedToken = null;
      this.verifiedBinInfo = null;
    },
    async generateReceipt(paymentContext) {
      if (paymentContext === 'TAX') {
        try {
          const payload = {
            processedPayment: this.processedPayment,
            paymentMethod: this.paymentMethod,
            emailReceipt: this.emailReceipt,
            // Lets the backend attach the "Email sent to ..." comment to the parcels actually
            // paid, instead of a comment with no taxYear/taxId at all.
            taxRecords: (this.taxDetails || [])
              .filter((item) => item && item.taxYear && item.taxId)
              .map((item) => ({ taxYear: item.taxYear, taxId: item.taxId })),
          };
          const receiptResponse = await backendRest.post('/tax/ccPayments/payrix/taxpayer-receipt', // backend route-handler will generate AND email the pdf receipt
            payload,
            { responseType: 'blob' }); // ensure response is treated as binary
          const blob = new Blob([receiptResponse.data], { type: 'application/pdf' });
          const blobUrl = window.URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        } catch (error) {
          console.error('Error while generating taxpayer cc receipt', error);
          this.flashError('Failed to generate Tax Payment receipt');
        } finally {
          this.overlay = false;
        }
      } else if (paymentContext === 'OD') {
        try {
          const payload = {
            processedPayment: this.processedPayment,
            odDepositData: this.odDepositData,
          };
          const receiptResponse = await backendRest.post('/od/ccPayments/payrix/deposit-receipt', payload,
            { responseType: 'blob' });
          const blob = new Blob([receiptResponse.data], { type: 'application/pdf' });
          const blobUrl = window.URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        } catch (error) {
          console.error('Error while generating OD cc receipt', error);
          this.flashError('Failed to generate Deposit receipt');
        } finally {
          this.overlay = false;
        }
      } else if (paymentContext === 'MISC') {
        try {
          const payload = {
            processedPayment: this.processedPayment,
            miscReceiptData: this.miscReceiptData,
            totalAmount: (this.payrixPaymentData && this.payrixPaymentData.totalAmount),
          };
          const receiptResponse = await backendRest.post('/misc/ccPayments/payrix/receipt', payload,
            { responseType: 'blob' });
          const blob = new Blob([receiptResponse.data], { type: 'application/pdf' });
          const blobUrl = window.URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        } catch (error) {
          console.error('Error while generating Misc cc receipt', error);
          this.flashError('Failed to generate Misc receipt');
        } finally {
          this.overlay = false;
        }
      } else if (paymentContext === 'MTG') {
        try {
          const payload = {
            processedPayment: this.processedPayment,
            mtgReceiptData: this.mtgReceiptData,
            totalAmount: (this.payrixPaymentData && this.payrixPaymentData.totalAmount),
          };
          const receiptResponse = await backendRest.post('/mtg/ccPayments/payrix/receipt', payload,
            { responseType: 'blob' });
          const blob = new Blob([receiptResponse.data], { type: 'application/pdf' });
          const blobUrl = window.URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        } catch (error) {
          console.error('Error while generating Mtg cc receipt', error);
          this.flashError('Failed to generate Mtg receipt');
        } finally {
          this.overlay = false;
        }
      }
    },
    submitPayment() {
      if (this.isProcessing) return;
      this.validatePhoneNumber();
      this.validateEmail();
      if (this.phoneNumberError || this.emailError) return;
      this.isProcessing = true;

      // For credit cards that are already verified, process payment directly
      if (this.payrixPaymentType === 'CREDIT' && this.isVerified) {
        this.processVerifiedPayment().catch((err) => {
          console.error('Payrix payment processing failed:', err);
          this.paymentMessage = `Payment error: ${err.message || 'Unexpected error'}`;
          this.isProcessing = false;
        });
        return;
      }

      // For ECHECK or unverified CREDIT, submit PayFields
      if (this.payrixPaymentType === 'ECHECK') {
        PayFields.config.amount = '0';
      }
      if (this.payrixPaymentType === 'CREDIT') {
        this.isVerifying = true;
      }
      // PayFields can swallow its own errors and never call back, so never wait
      // on it indefinitely.
      this.startSubmitWatchdog();
      PayFields.submit();
    },
    async processVerifiedPayment() {
      // Process payment using the verified token and bin info
      let cartContents;
      if (this.paymentContext === 'TAX') {
        cartContents = this.taxCartContents;
      } else if (this.paymentContext === 'MISC') {
        cartContents = this.miscReceiptData;
      } else if (this.paymentContext === 'MTG') {
        cartContents = this.mtgReceiptData;
      } else {
        cartContents = this.odDepositData;
      }

      this.processedPayment = await processPayment(
        this.verifiedToken,
        this.phoneNumber,
        this.email,
        (this.payrixPaymentData && this.payrixPaymentData.totalAmount),
        cartContents,
        this.paymentSettingItem,
        this.payrixPaymentType,
        this.paymentContext,
        (this.payrixPaymentData && this.payrixPaymentData.ownerName),
        this.requestId,
        this.verifiedBinInfo,
        this.resolvedMerchantId,
      );

      if (this.processedPayment && this.processedPayment.success) {
        this.paymentMessage = 'Payment successful!';
        this.phoneNumber = this.processedPayment.phoneNumber || '';
        this.email = this.processedPayment.emailAddress || '';
        const returnedCardholderName = this.processedPayment.cardholderName || '';
        const fallbackOwnerName = (this.payrixPaymentData && this.payrixPaymentData.ownerName) || '';
        this.cardholderName = returnedCardholderName.length > 2
          ? returnedCardholderName : fallbackOwnerName;
        this.cardType = this.processedPayment.cardType || '';
        this.paymentMethod = `${this.cardType}_PAYRIX`;

        this.setPaymentSuccessFlag({
          flag: true,
          transactionId: this.processedPayment.transactionId || '',
        });
        this.setPayrixPaymentType(this.payrixPaymentType);
        this.setCardholderInfo({
          phone: this.phoneNumber,
          email: this.email,
          cardholderName: this.cardholderName,
          paymentMethod: this.paymentMethod,
        });
        await this.generateReceipt(this.paymentContext);
        // Close modal after successful payment
        this.isProcessing = false;
        this.handleClose();
        return;
      }
      if (this.processedPayment.reason === 'declined') {
        this.paymentMessage = 'Payment was declined.';
      } else if (this.processedPayment.reason === 'unknown_status') {
        this.paymentMessage = 'Payment status unknown. Please check your ReNewGov Portal.';
      } else if (this.processedPayment.error) {
        this.paymentMessage = `Payment failed: ${this.processedPayment.error}`;
      } else {
        this.paymentMessage = 'Payment could not be processed. Please try again.';
      }
      this.processedPayment = null;

      this.isProcessing = false;
      this.phoneNumber = null;
      this.email = null;
      // Reset verification state
      this.isVerified = false;
      this.verifiedToken = null;
      this.verifiedBinInfo = null;
    },
    handleSwipeCard() {
      PayFields.swipePopup();
      if (this.swipeDiag) this.swipeDiag.openSwipeWindow('reswipe_button');
    },
    cancelVerification() {
      // Reset verification state back to original form
      this.isVerified = false;
      this.isVerifying = false;
      this.verifiedToken = null;
      this.verifiedBinInfo = null;
      this.paymentMessage = null;
    },
    onEmailReceiptToggle(value) {
      console.info('emailReceipt value: ', this.emailReceipt);
      this.emailReceipt = !!value;
      this.validateEmail();
    },
  },
};
</script>

<style scoped>
.title-position {
  padding: 0.5rem 0.5rem 1.25rem 0.25rem !important;
  margin-left: -0.25rem;
  margin-top: -0.5rem;
  font-size: 1.25rem;
}
.header-class {
  background-color: #363a40;
  color: white;
}
#phone-number,#custom-routing,
#email {
  width: 100%;
  height: 2.5rem;
  padding: 0.5rem 0;
  margin-bottom: 0.6275rem;
  border: none;
  border-bottom: 0.0625rem solid #ccc;
  border-radius: 0;
  font-size: 0.875rem;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s;
  background-color: transparent;
}
.input-field {
  padding-bottom: 2.5rem;
}
#phone-number:focus,
#email:focus {
  border-bottom: 0.125rem solid #4285f4;
}
#phone-number::placeholder,
#email::placeholder {
  color: #757575;
}
#tmc-blue {
  color: #1976D2;
}
.invalid-input {
  border: 0.0625px solid red !important;
}
.error-text {
  color: red;
  font-size: 0.75rem;
}
.fee-row {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.payment-submit-btn.v-btn.v-btn--disabled {
  background-color: #044007 !important;
  color: white !important;
  opacity: 0.8;
}
.swipe-btn {
  background-color: white !important;
  color: darkblue !important;
  font-size: 0.75rem;
}
.accepted-card-icon {
  height: 3rem;
  margin: 0 0.3rem;
}
.adjusted-text {
  font-size: 0.875rem;
}
.form-row {
  margin-bottom: 0.25em;
  width: 100%;
}
.input-field label,
.form-row label,
label[for="account_type"],
label[for="routing"],
label[for="account_number"],
label[for="number"],
label[for="expiration"],
label[for="cvv"],
label[for="name"] {
  font-size: 0.625rem;
  color: darkslategray;
  font-weight: 500;
}
.form-error {
  height: 0.75em;
}
.or-divider {
  margin-top: 0.125rem !important;
  margin-bottom: 0.125rem !important;
  height: 1.5rem;
}
.or-text {
  line-height: 1;
  padding: 0;
}
.card-group-section {
  margin-top: 3rem !important;
}
.submit-button-row {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
.bank-name-display {
  margin-top: -0.5rem;
  margin-bottom: 0.75rem;
}
.bank-name-text {
  font-size: 0.75rem;
  color: #4285f4;
  font-weight: 500;
}
.missing-bank-display,
.invalid-routing-display {
  margin-top: -0.5rem;
  margin-bottom: 0.75rem;
}
.missing-bank-text,
.invalid-routing-text {
  font-size: 0.75rem;
  color: #f44336;
  font-weight: bolder;
}
.missing-bank-text {
  background-color: #e1d226;
  padding: 2px 4px;
  border-radius: 2px;
}
.verified-fee-section {
  background-color: #e3f2fd;
  border-radius: 8px;
  margin: 0.5rem 0;
}
.verified-card-type {
  font-size: 1rem;
  font-weight: bold;
  color: #1565c0;
}
.verified-fee-details,
.verified-total-details {
  font-size: 0.95rem;
  margin: 0.25rem 0;
}
.verified-label {
  color: #666;
  margin-right: 0.5rem;
}
.verified-value {
  color: #1565c0;
  font-size: 1rem;
}
.verified-total-details .verified-value {
  font-size: 1.1rem;
}
.cancel-verify-btn {
  min-width: 80px;
}
</style>
